import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/LowPrices.module.scss'

import { Container, Image, Modal } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'

class LowPrices extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show_video_modal: false
    }
  }

  openVideoModal = () => {
    this.setState({ 
      show_video_modal: true
    });
  }

  closeVideoModal = () => {
    this.setState({ 
      show_video_modal: false
    });
  }

  extractRutubeVideoId(url) {
    // Функция для извлечения ID видео из Rutube URL
    if (!url) return null;
    
    // Для ссылки вида: https://rutube.ru/video/a8dbc0f7ad3db205eca295af373591c6/
    const regExp1 = /rutube\.ru\/video\/([a-zA-Z0-9]+)/;
    // Для embed ссылки: https://rutube.ru/play/embed/a8dbc0f7ad3db205eca295af373591c6/
    const regExp2 = /rutube\.ru\/play\/embed\/([a-zA-Z0-9]+)/;
    
    const match1 = url.match(regExp1);
    const match2 = url.match(regExp2);
    
    if (match1 && match1[1]) return match1[1];
    if (match2 && match2[1]) return match2[1];
    
    return null;
  }

  getRutubeEmbedUrl(videoId) {
    if (!videoId) return null;
    return `https://rutube.ru/play/embed/${videoId}/`;
  }
  
  render() {

    const { data, assets_path } = this.props
    const { show_video_modal } = this.state;

    const videoId = data?.href ? this.extractRutubeVideoId(data.href) : null;
    const embedUrl = videoId ? this.getRutubeEmbedUrl(videoId) : '';

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={`[GOODWIN]`}
            className={styles.title}
          />
          <div className={styles.leftblock_href_mob}>
            <a href='/zavod'>
              <GreenButton
                text={`Подробнее о заводе`}
                width={163}
              />
            </a>
            <div>[GOODWIN]</div>
          </div>
          <div className={styles.content}>
            <div className={styles.leftblock}>
              <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text_1}} />
              <div className={styles.line}>
                <div className={styles.icon}>
                  <Image src={`/${assets_path}/images/color-swatch.svg`} width={21} height={21} />
                </div>
                <div>
                  <div>Производство оснащено оборудованием ведущих европейских фирм</div>
                  <div className={styles.line_companys}>{data?.companys}</div>
                </div>
                <a className={styles.leftblock_href} href='/zavod'>
                  <GreenButton
                    text={`Подробнее о заводе`}
                    width={163}
                  />
                </a>
              </div>
              <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text_2}} />
            </div>
            
            {/* Заменяем ссылку на div с обработчиком клика */}
            <div 
              className={styles.rightblock}
              onClick={this.openVideoModal}
              role="button"
              tabIndex={0}
              onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal()}
            >
              <Image src={data?.image} width={457} height={272} alt='Видеоролик' />
              <div className={styles.rightblock_content}>
                <GreenButton
                  text={`Видеоролик`}
                  width={122}
                  svg={(
                    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.5 4.63397C9.16667 5.01888 9.16667 5.98113 8.5 6.36603L1.75 10.2631C1.08333 10.648 0.25 10.1669 0.25 9.39711L0.250001 1.60289C0.250001 0.833085 1.08333 0.35196 1.75 0.73686L8.5 4.63397Z" fill="#00C775"/>
                    </svg>
                  )}
                />
                <div>Смотреть видео о производстве окон</div>
              </div>
            </div>
          </div>

          {/* Модальное окно для видео */}
          <Modal 
            show={show_video_modal} 
            onHide={this.closeVideoModal}
            size="lg"
            centered
            className={styles.video_modal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Видео о производстве окон</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              {embedUrl ? (
                <div className={styles.video_container}>
                  <iframe
                    src={embedUrl}
                    width="100%"
                    height="405"
                    frameBorder="0"
                    style={{ border: 'none' }}
                    allow="clipboard-write; autoplay"
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                    title="Видео о производстве окон"
                  />
                </div>
              ) : (
                <p>Неверная ссылка на видео</p>
              )}
            </Modal.Body>
          </Modal>
        </Container>
      </section>
    )
  }
}

LowPrices.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string
}

LowPrices.defaultProps = {
  data: {},
  assets_path: ``
}

export default LowPrices